<script>
import { defineComponent, ref, watch, nextTick, getCurrentInstance, computed } from 'vue'
import { ValidationObserver } from 'vee-validate'
import { validateSKU } from '@/api/product'
import { useSaveSectionOnScroll } from './../useSaveSectionOnScroll'
import FormItem from '@/components/Input/FormItem.vue'
import Checkbox from '@/components/Input/Checkbox.vue'
import SingleVariant from './SingleVariant.vue'
import MultiVariant from './MultiVariant/index.vue'
import isEqual from 'lodash/isEqual'
import route from '@/router'

/**
 * @template T
 * @typedef {import('@vue/composition-api').Ref<T>} Ref
 */
/**
 * @typedef {import('@/types/product').ProductFormModel} ProductFormModel
 */
export default defineComponent({
  name: 'TypeAndPrice',
  components: {
    ValidationObserver,
    FormItem,
    Checkbox,
    SingleVariant,
    MultiVariant,
  },
  props: {
    businessId: {
      type: String,
      default: '',
    },
    business: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    errorBundling: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { $confirm } = getCurrentInstance().proxy.$root

    const { dirty, el, validationObserver } = useSaveSectionOnScroll(emit)

    /** @type {Ref<ProductFormModel} */
    const model = ref(props.value)
    const tempSKU = ref([])
    const existSKU = ref([])

    watch(() => props.value, (product) => {
      model.value = product
    }, { deep: true, immediate: true })
    watch(() => model.value.catalogs, (catalog, old) => {
      isUseVariation.value = !!catalog.attributes && Object.keys(catalog.attributes).length > 0

      if (!isEqual(catalog, old)) {
        nextTick(() => emit('input', model.value))
      }
    }, { deep: true })
    watch(() => [model.value.detail.title, model.value.catalogs.attributes], () => {
      model.value.catalogs.items.forEach(item => {
        item.title = [
          model.value.detail.title,
          (Object.values(item.option || {}) || []).join(', '),
        ].filter(Boolean).join(' - ')
      })
    }, { deep: true })


    const isUseVariation = ref(!!props.value.catalogs.options)
    watch(isUseVariation, (value) => {
      if (!value) {
        model.value.catalogs = {
          ...model.value.catalogs,
          attributes: {},
          options: [],
          items: [{
            ...model.value.catalogs.items[0],
            title: model.value.detail.title,
            price: {
              ...model.value.catalogs.items[0].price,
              currency: route.app._route.meta.title === 'Powerbiz - Add Product Redeem' || route.app._route.meta.title === 'Powerbiz - Edit Product Redeem'
                ? 'Koin' : model.value.catalogs.items[0].price.currency,
            },
          }],
        }
      } else if (model.value.catalogs.items.length > 1 && (route.app._route.meta.title === 'Powerbiz - Add Product Redeem' || route.app._route.meta.title === 'Powerbiz - Edit Product Redeem')) {
        model.value.catalogs = {
          ...model.value.catalogs,
          items: model.value.catalogs.items?.map(v => {
            const temp = {
              ...v,
              price: {
                ...v.price,
                currency: 'Koin',
              },
            }
            return temp
          }),
        }
      }
    }, { immediate: true })
    const useVariationTimestamp = ref(0)
    const onUseVariationChange = (value) => {
      useVariationTimestamp.value = Date.now() // hack to force update :)
      if (isUseVariation.value && !value) {
        $confirm({
          icon: () => null,
          title: 'Hapus Varian',
          content: 'Jika dirubah, data varian yang telah dimasukkan akan berubah dan tipe varian akan hilang dari pilihan varian, lho.',
          okText: 'Ya, Hapus',
          onOk: () => isUseVariation.value = value,
        })
      } else {
        isUseVariation.value = value
      }
    }

    const onCheckSKU = async (value) => {
      model.value.catalogs.items[value.id].loading = true
      await validateSKU({
        business_id: props.business.business_id,
        data: {
          sku: value.sku,
          id: model.value.catalogs.items[value.id].id,
          product_id: model.value.id,
        },
      })
      .then(() => {
        model.value.catalogs.items[value.id].msg = ''
        existSKU.value[value.id] = ''
        emit('exist', existSKU.value)
      })
      .catch(err => {
        if(err?.response?.data?.message?.includes('exists')) {
          model.value.catalogs.items[value.id].msg = 'SKU sudah terdaftar'
          existSKU.value[value.id] = value.sku
          emit('exist', existSKU.value)
        }
      })
      .finally(() => model.value.catalogs.items[value.id].loading = false)
    }

    const isRedeemProductRoute = computed(() => {
      const currentRoute = route.app._route
      return currentRoute.name?.includes('redeem-product-channel') ||
             currentRoute.path?.includes('redeem-product-channel/')
    })

    return {
      el,
      dirty,
      validationObserver,
      model,
      isUseVariation,
      onUseVariationChange,
      useVariationTimestamp,
      onCheckSKU,
      isRedeemProductRoute,
    }
  },
})
</script>

<template>
  <a-card ref="el">
    <ValidationObserver ref="validationObserver">
      <h4 class="">
        {{ $t('product.product_type_and_price') }}
      </h4>
      <div class="text-muted mb-4">
        {{ $t('product.variant_desc') }}
      </div>

      <!-- <FormItem>
        <div class="vat-options">
          <label>
            <input
              v-model="model.detail.vat_type"
              type="radio"
              name="vat"
              value="INCLUDE"
              :disabled="!!$route.query.id"
            />
            <div>{{ $t('product.price-include-vat') }}</div>
          </label>
          <label>
            <input
              v-model="model.detail.vat_type"
              type="radio"
              name="vat"
              value="EXCLUDE"
              :disabled="!!$route.query.id"
            />
            <div>{{ $t('product.price-exclude-vat') }}</div>
          </label>
          <label>
            <input
              v-model="model.detail.vat_type"
              type="radio"
              name="vat"
              value="NONE"
              :disabled="!!$route.query.id"
            />
            <div>{{ $t('product.price-no-vat') }}</div>
          </label>
        </div>
      </FormItem> -->

      <FormItem v-if="!isRedeemProductRoute" :key="useVariationTimestamp" tag="div">
        <Checkbox :value="isUseVariation" :label="$t('product.product_variant')" :disabled="!!$route.query.id" @input="(value) => onUseVariationChange(value)" />
      </FormItem>

      <section v-if="!isUseVariation">
        <SingleVariant
          v-model="model"
          :business-id="businessId"
          :business="business"
          :error-bundling="errorBundling"
          @checksku="onCheckSKU"
          @err="e => $emit('err', e)"
        />
      </section>

      <section v-else>
        <MultiVariant
          v-model="model"
          :business="business"
          @changeuom="val => $emit('changeuom', val)"
          @checksku="onCheckSKU"
        />
      </section>
    </ValidationObserver>
  </a-card>
</template>

<style>
.existing .ant-input {
  border-color: red;
}
</style>
<style scoped lang="scss">
.vat-options {
  margin-left: -.5rem;
  margin-right: -.5rem;

  input {
    display: none;
  }

  label {
    padding: 0 .5rem;
    line-height: 1.5;

    div {
      padding: .35rem 1rem;
      border: 1px solid #4D4D4D;
      border-radius: 5rem;
      cursor: pointer;
      transition: .1s all ease-in;
    }

    input:checked {
      + div {
        background: #4D4D4D;
        color: #fff;
      }
    }
  }
}
</style>
